import EmbedPathway from "@/components/EmbedPathway";

const Embed = () => {
  // Get URL parameters for customization
  const urlParams = new URLSearchParams(window.location.search);
  const compact = urlParams.get('compact') === 'true';
  const showHeader = urlParams.get('header') !== 'false';
  const showFooter = urlParams.get('footer') !== 'false';
  const maxWidth = urlParams.get('width') || '4xl';

  return (
    <EmbedPathway 
      compact={compact}
      showHeader={showHeader}
      showFooter={showFooter}
      maxWidth={maxWidth}
    />
  );
};

export default Embed;